import {ProductComboProvider} from '@/context/ProductCombo/ProductComboContext'
import {CreateProductCombo as CreateProductComboNorthAmerica} from '@/features/ProductCombo/CreateProductCombo'
import {selectIsNorthAmerica} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import {CreateProductCombo} from './CreateProductCombo'

/**
 * Reusable Product Combo editor shell backed by ProductCombo context.
 * @param {{
 *   initialState?: import('@/types/productComboTypes').ProductCombo,
 *   initialStep?: number,
 * }} props
 * @returns {JSX.Element}
 */
export const ProductComboEditor = ({initialState, initialStep}) => {
  const isNorthAmerica = useSelector(selectIsNorthAmerica)

  return (
    <ProductComboProvider initialState={initialState} initialStep={initialStep}>
      {isNorthAmerica ? <CreateProductComboNorthAmerica /> : <CreateProductCombo />}
    </ProductComboProvider>
  )
}
